module.exports = __webpack_public_path__ + "img/image_body-product_03.8f06c5ad.jpg";